export default {
  bex: {
    type: "swap",
    theme: {
      "--button-color": "rgb(249, 247, 245)",
      "--button-text-color": "rgb(31, 28, 25)"
    },
    icon: "/images/dapps/bex.svg"
  },
  "ooga-booga": {
    type: "swap",
    theme: {
      "--button-color": "rgb(245, 194, 66)",
      "--button-text-color": "rgb(78, 60, 39)"
    },
    icon: "/images/dapps/ooga-booga.svg"
  },
  kodiak: {
    type: "swap",
    theme: {
      "--button-color": "rgb(48, 131, 220)",
      "--button-text-color": "#fff"
    },
    icon: "/images/dapps/kodiak.svg"
  },
  burrbear: {
    type: "swap",
    theme: {
      "--button-color": "rgb(255, 120, 7)",
      "--button-text-color": "#fff"
    },
    icon: "/images/dapps/burrbear.svg"
  }
};
